// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"classes_Paragraph__3l_b4","buttonCheckBox":"classes_buttonCheckBox__3t3Yy","CheckboxButton":"classes_CheckboxButton__GsMvf"};